/**
 * Class Notifier
 * Manages snackbar messages.
 *
 * To open the snackbar use show es.: notifierService.show(new Message('message', 'success', Severity.SUCCESS))
 * To close the snackbar use hide es.: notifierService.hide()
 * Choose auto-dismiss after timing by severity level (choose duration 0 for no auto-dismiss message)
 */

import { HttpErrorResponse } from '@angular/common/http';
import { IMessage } from '../model/message';
import { Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarRef, SimpleSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class NotifierService {
  constructor(public snackBar: MatSnackBar) { }

  /** show snackbar message */
  show(error: IMessage): MatSnackBarRef<SimpleSnackBar> {
    if (!error || !error.message.length) {
      return;
    }

    const config = {
      duration: error.duration,
      panelClass: error.severity
    };

    const action = error.action ? error.action : undefined;
    return this.snackBar.open(error.message, action, config);
  }

  /** hide active snackbar message */
  hide(): void {
    return this.snackBar.dismiss();
  }

  logError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
        console.error(error);
    } else {
        console.error(error);
    }
  }
}
